import { Controller } from "@hotwired/stimulus"

// Manages the customer order history dialog and reimport functionality.
// Connects to data-controller="erp--customer-history"
export default class extends Controller {
  static targets = ["dialog", "status"]
  static values = { url: String, waitMessage: String }

  connect() {
    this._restoreFocus = () => this._opener?.focus()
    this.dialogTarget.addEventListener("close", this._restoreFocus)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this._restoreFocus)
  }

  open(event) {
    // In the editor, the history waits for the edits to be saved; the estimate page has no form
    const editorForm = this.element.closest("form")
    if (editorForm && editorForm.dataset.saveState !== "saved") return

    const frame = this.dialogTarget.querySelector("turbo-frame")
    if (frame && this.urlValue) {
      if (frame.getAttribute("src") === this.urlValue && typeof frame.reload === "function") frame.reload()
      else frame.src = this.urlValue
    }
    this._opener = event?.currentTarget || document.activeElement
    this.dialogTarget.showModal()
    this.dialogTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  // The line is serialized server-side in the shape the textile picker emits, so a past line
  // comes back with its own nature — catalogue or customer-supplied — and its size breakdown.
  reimport(event) {
    event.preventDefault()

    const line = JSON.parse(event.currentTarget.dataset.line || "null")
    if (!line) return

    const editor = document.querySelector("[data-controller*='erp--estimate-editor']")
    if (editor?.closest("form")?.dataset.saveState !== "saved") {
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = this.waitMessageValue
        this.statusTarget.classList.remove("hidden")
      }
      return
    }
    if (editor) {
      const [ name, detail ] = line.customer_supplied
        ? [ "custom-selected", { ...line, quantity: parseInt(event.currentTarget.dataset.quantity) || 0 } ]
        : [ "items-selected", { colours: [ { ...line, quantity: parseInt(event.currentTarget.dataset.quantity) || 0 } ] } ]

      editor.dispatchEvent(new CustomEvent(`erp--textile-picker:${name}`, { detail, bubbles: true }))
    }

    this.dialogTarget.close()
  }
}
